import sclasses from '../SetCourseClassDirectionModal/index.module.css'

const CreateLinkTabType = ({
  value,
  onChange,
}: {
  value?: string
  onChange?: (value: string) => void
}) => (
  <div className={sclasses.selectTypeWrapper}>
    <button
      type="button"
      className={
        value === 'course' ? sclasses.tabButtonActive : sclasses.tabButton
      }
      onClick={() => onChange?.('course')}
    >
      Курс
    </button>
    <button
      type="button"
      className={
        value === 'class' ? sclasses.tabButtonActive : sclasses.tabButton
      }
      onClick={() => onChange?.('class')}
    >
      Класс/Траектория
    </button>
  </div>
)

export default CreateLinkTabType
